import { Card, Modal } from "react-bootstrap";
import CustomStore from "devextreme/data/custom_store";
import React, { useCallback, useMemo, useRef, useState } from "react";
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Selection, Summary, TotalItem } from "devextreme-react/cjs/data-grid";
import notistack from "modules/core/notistack";
import { getSalesOrderForReturnBySearch } from "../services/CustomerToFranchaiase.service";
import { BiSolidRightArrowAlt } from "react-icons/bi";
import ShowCustomerToFranchiseItems from "./ShowCustomerToFranchiseItems";
import { apiClient } from "helpers/api_helper";
import { HasPermission } from "Layout/Permissions/permissionsCache";
import Loader from "Common/Loader";

const CustomrToFranchiaseList = () => {
    const [searchInvoice, setSearchInvoice] = useState("");
    const [shouldSearch, setShouldSearch] = useState(false);
    const dataGridRef = useRef<DataGrid>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);


    const dataSource = useMemo(() => {
        return new CustomStore({
            key: "id",
            load: async () => {
                try {
                    if (!shouldSearch || !searchInvoice.trim()) {
                        return {
                            data: [],
                            totalCount: 0
                        };
                    }

                    const response = await getSalesOrderForReturnBySearch(searchInvoice);
                    const responseData = response?.data || [];
                    return {
                        data: responseData,
                        totalCount: responseData.length
                    };

                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            }
        });
    }, [shouldSearch, searchInvoice]);

    const handleSearchClick = () => {
        if (searchInvoice.trim() === "") {
            notistack.warning("Enter Invoice No or Customer Mobile No");
            return;
        }
        setShouldSearch(true);
    };
    const [orderItems, setOrderItems] = useState<any[]>([]);
    // const updateIconSidebar = async () => {
    //     const hasSelectedRows = selectedRows?.length > 0;
    //     if (!hasSelectedRows) {
    //         notistack.warning('Please select a product.')
    //         return
    //     }
    //     setShowModal(true)
    // };

    const updateIconSidebar = async () => {
        const hasSelectedRows = selectedRows?.length > 0;
        if (!hasSelectedRows) {
            notistack.warning('Please select a product.');
            return;
        }

        try {
            // Assuming your selected row has `id` or `salesorderId`
            const salesOrderId = selectedRows[0]?.id; // or selectedRows[0]?.salesorderId
            if (!salesOrderId) {
                notistack.warning("Invalid Sales Order selected.");
                return;
            }
            setIsSubmitting(true);

            const response = await apiClient.get(`api/v1/ReturnSalesOrder/GetSalesOrderForReturnBySearch?salesorderId=${salesOrderId}`);
            const responseData = response?.data || [];

            if (responseData.length === 0) {
                notistack.warning("No items found for this Sales Order.");
                return;
            }
            setOrderItems(responseData);
            setShowModal(true);

        } catch (error) {
            console.error("Error fetching sales order items:", error);
            notistack.error("Failed to load sales order items.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const [refreshKey, setRefreshKey] = useState(0);

    const reloadDataSource = () => {
        setRefreshKey((prev) => prev + 1);
    };

    const closeModal = () => {
        setShowModal(false)
    }
    const [showModal, setShowModal] = useState(false)


    const [selectedRows, setSelectedRows] = useState<any[]>([]);

    return (
        <React.Fragment>
            {isSubmitting && <Loader />}
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5 className="m-0">Return Customer To Franchise</h5>
                            {HasPermission('ReturnSalesOrder.Write') &&
                                <div className="d-flex align-items-center gap-2">
                                    <input
                                        type="text"
                                        placeholder="Enter Invoice No or Customer Mobile No"
                                        className="form-control"
                                        title="Enter Invoice No or Customer Mobile No"
                                        style={{ width: "200px" }}
                                        value={searchInvoice}
                                        onChange={(e) => setSearchInvoice(e.target.value)}
                                        onKeyDown={(e) => e.key === "Enter" && handleSearchClick()}
                                    />
                                    <button onClick={handleSearchClick} className="submit-btn">
                                        Search
                                    </button>
                                    <button onClick={updateIconSidebar} disabled={isSubmitting} className="btn submit-btn">
                                        <BiSolidRightArrowAlt size={15} />
                                    </button>
                                </div>
                            }
                        </Card.Header>

                        <Card.Body className="pt-0">
                            {HasPermission('ReturnSalesOrder.Read') &&
                                <DataGrid
                                    dataSource={dataSource}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    ref={dataGridRef}
                                    showBorders={true}
                                    key={refreshKey}
                                    // onSelectionChanged={(e) => setSelectedRows(e.selectedRowsData)}
                                    onSelectionChanged={(e) => {
                                        if (e.selectedRowKeys.length > 1) {
                                            const latestKey = e.selectedRowKeys[e.selectedRowKeys.length - 1];
                                            e.component.selectRows([latestKey], false); // false = clear old selection
                                            setSelectedRows([e.selectedRowsData[e.selectedRowsData.length - 1]]);
                                        } else {
                                            setSelectedRows(e.selectedRowsData);
                                        }
                                    }}
                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}
                                >
                                    <Scrolling
                                        mode='standard'
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />
                                    <Selection
                                        mode="multiple"
                                    />
                                    <Pager
                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 25, 50, 100]}

                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />
                                    <Summary>
                                        <TotalItem
                                        // column="Sr.No."
                                        // summaryType="count"
                                        // displayFormat="Total: {0}"
                                        />
                                    </Summary>
                                    <Paging defaultPageSize={10} />
                                    <SearchPanel visible width={240} />

                                    <Column allowFiltering={true} dataField="invoiceName" caption="Invoice No." dataType="string" width={180} />
                                    <Column allowFiltering={false} dataField="invoiceDate" caption="Invoice Date" dataType="date" format="dd/MM/yyyy" width={160} />
                                    <Column allowFiltering={true} dataField="customerName" caption="Customer Name" dataType="string" width={200} />
                                    <Column allowFiltering={true} dataField="mobileNo" caption="Mobile No" dataType="string" width={150} />
                                    <Column allowFiltering={true} dataField="salesPersonName" caption="Sales Person" dataType="string" width={200} />
                                    <Column allowFiltering={false} dataField="totalAmount" caption="Total Amount" dataType="number" format="#,##0.00" width={160} />
                                </DataGrid>
                            }
                        </Card.Body>
                    </Card>
                </div>
            </div>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                className="fade"
                size="lg"
                dialogClassName="modal-dialog-centered"
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Items</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ShowCustomerToFranchiseItems closeModal={closeModal} reloadDataSource={reloadDataSource} data={orderItems!} />
                </Modal.Body>
            </Modal>
        </React.Fragment>
    );
};

export default CustomrToFranchiaseList;